var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-breadcrumb u-3-of-5"},[_c('router-link',{staticClass:"c-breadcrumb__item c-breadcrumb__link",attrs:{"exact":"","to":{ name: 'cis.sessions'}}},[_vm._v(" "+_vm._s(_vm.$t('cis'))+": "+_vm._s(_vm.$t('home'))+" ")]),(_vm.session)?[_c('span',{staticClass:"c-breadcrumb__item"},[_vm._v(_vm._s(_vm.session.name))])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }